import getBlocks from './blocks';

const getBlock = (rootState, blockId) =>
  getBlocks(rootState).find((block) => block.id === blockId) || null;

export default getBlock;
